import Vue from 'vue';
import { CheeersConfig } from '@/config';

export default function BootstrapConfig(config: CheeersConfig): CheeersConfig {
  Vue.prototype.$config = config;
  return config;
}
